import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
`

export const GridItem = styled.div`
  cursor: pointer;
  transition: 0.15s ease opacity;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.5;
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`
